import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: '404',
    },
  },
 {
   name: '404',
   path: '/404 ',
   component: () => import('./view/404'),
   meta: {
     title: '404',
   },
 },
  {
    name: 'register',
    path: '/register/:tel',
    component: () => import('./view/register'),
    meta: {
      title: '註冊頁',
    },
  },
  {
    name: 'msg',
    path: '/msg/:tel',
    component: () => import('./view/msg'),
    meta: {
      title: '補充資料',
    },
  },
	{
	  name: 'index',
	  path: '/index',
	  component: () => import('./view/index'),
	  meta: {
	    title: '會員資料完善 - 教圖家長會',
	  },
	},
	{
	  name: 'userTermsHK',
	  path: '/userTermsHK',
	  component: () => import('./view/userTerms/userTermsHK'),
	  meta: {
	    title: '使用條款與細則',
	  },
	},
	{
	  name: 'userTermsEN',
	  path: '/userTermsEN',
	  component: () => import('./view/userTerms/userTermsEN'),
	  meta: {
	    title: 'Terms and Conditions',
	  },
	},
	{
	  name: 'privacyPolicyHK',
	  path: '/privacyPolicyHK',
	  component: () => import('./view/privacyPolicy/privacyPolicyHK'),
	  meta: {
	    title: '隱私政策',
	  },
	},
	{
	  name: 'privacyPolicyEN',
	  path: '/privacyPolicyEN',
	  component: () => import('./view/privacyPolicy/privacyPolicyEN'),
	  meta: {
	    title: 'Privacy Policy Statement',
	  },
	},
	{
	  name: 'logoffConfirmHK',
	  path: '/logoffConfirmHK',
	  component: () => import('./view/logoffConfirm/logoffConfirmHK'),
	  meta: {
	    title: '刪除賬戶',
	  },
	},
	
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
